module.exports = __webpack_public_path__ + "img/wall.32ffe734.png";